import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fcom-selectable-card-content',
  template: '<ng-content></ng-content>',
  styleUrls: ['./selectable-card-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SelectableCardContentComponent {}
